import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MasterPrefectureApiResponse, MASTER_PREFECTURE_INIT } from '../types/api/MasterPrefectureApiType';

// 都道府県、市区町村のマスタ管理
const slice = createSlice({
    name: 'MasterPrefectureData',
    // 初期値
    initialState: MASTER_PREFECTURE_INIT,
    reducers: {
        // 全置換
        setState: (_state, action: PayloadAction<MasterPrefectureApiResponse>) => action.payload,
        // 初期化
        initState: () => MASTER_PREFECTURE_INIT,
    },
});

export const { actions, reducer } = slice;
export const { setState, initState } = actions;
